/**
 * @hidden
 */
var canUseDOM = Boolean(
// from fbjs
typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
export { canUseDOM };



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-common/dist/es/canUseDOM.js
// module id = 777
// module chunks = 93